import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import {
  scaleTime,
  Chart,
  Grid,
  LineChart,
  ScatterChart,
  XAxis,
  YAxis,
} from '@dbk/ui-charts';

import { PALETTE } from '../../../../constants';
import Interactions from './interactions';
import NoDataChart from '../../../../components/common/no-data-chart';
import {
  getChartData,
  formatDateLabel,
  getXSmallTicks,
  getYAxisDomain,
  getYAxisDivisorIndex,
  getYAxisTitle,
  getYTickFormatter,
} from './utils';

import styles from './price-history-chart.styles';
import { createContainer } from '@dbk-legacy/muster/react';

const NUM_DAYS = 5;

class PriceHistoryChart extends PureComponent {
  static propTypes = {
    ...Chart.propTypes,
    data: PropTypes.arrayOf(PropTypes.object),
    currency: PropTypes.string,
    selectedInteractionValue: PropTypes.instanceOf(Date),
    onInteractionChange: PropTypes.func,
    screen: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
      isSmall: PropTypes.bool,
    }).isRequired,
  };

  static defaultProps = {
    data: [],
    ratio: 2,
    margins: { left: 43, right: 0, top: 54, bottom: 30 },
    paddings: { left: 50, right: 22, top: 40, bottom: 10 },
    screen: {
      isSmall: false,
    },
  };

  getOuterComponents(data, chartData) {
    const {
      currency,
      selectedInteractionValue,
      onInteractionChange,
      margins,
      outerComponents,
      i18n: {
        messages
      }
    } = this.props;

    const noDataMarginTop = margins && margins.top ? margins.top * -1 : 0;
    const chartOuterComponents = data.length
      ? <Interactions
        currency={currency}
        key="interactions"
        data={chartData}
      />
      : <NoDataChart
        key="no-data"
        marginTop={noDataMarginTop}
        messages={messages}
      />;

    if (outerComponents) {
      return [
        ...[ chartOuterComponents ],
        ...outerComponents,
      ];
    }

    return chartOuterComponents;
  }

  xTickFormatter (date){
    const{ i18n: {
      messages
    }
  } = this.props;
    if (date){
      return formatDateLabel(date,messages)
    }
   }


  render() {
    const {
      children,
      data,
      currency,
      height,
      width,
      margins,
      selectedInteractionValue,
      screen,
      i18n: {
        messages
      }
    } = this.props;
    const ratio = height != null && width != null ? null : this.props.ratio;
    const validData = data.filter(({ price }) => price.value !== null);

    const yAxisDomain = getYAxisDomain(validData);
    const yAxisDivisorIndex = getYAxisDivisorIndex(yAxisDomain);
    const yTickFormatter = getYTickFormatter(yAxisDivisorIndex);
    //const xTickFormatter = formatDateLabel(date,messages);
    const chartData = getChartData(validData, NUM_DAYS);
    const chartMargins = !!validData.length ? margins : { ...margins, left: 0 };
    const animated = selectedInteractionValue != null ? false : undefined;

     if(chartData.length <2) {
      return (<NoDataChart
        key="no-data"
        messages={messages}
      />);
    }

    let chartWrapper = {};
    if (!screen.isSmall) {
      chartWrapper = {
        flex: 1,
        alignSelf: 'flex-start',
        marginBottom: 10,
        // height: screen.height * 0.6,
        width: screen.width * 0.5,
      };
    }

    console.log('RENDERING THIS');
    return (
      <View style={chartWrapper}>
      <Chart
        axis={{
          x: {
            accessor: row => row.x,
            tickFormatter: row => this.xTickFormatter(row),
            ticks: chartData => chartData,
            scale: scaleTime,
          },
          y: {
            tickFormatter: yTickFormatter,
            domain: yAxisDomain,
          },
        }}
        animated={animated}
        {...this.props}
        data={chartData}
        margins={chartMargins}
        ratio={ratio}
        minWidth={80}
        minHeight={80}
      >
        <XAxis
          key="xaxis"
          styles={{
            lineStyle: styles.yAxis,
            tickStyle: styles.xAxisSmall,
            tickLabelColor: styles.tickLabel.color,
            tickLength: 2,
          }}
        />
        {!!validData.length && [
          <YAxis
            labelText={getYAxisTitle(yAxisDivisorIndex, currency,messages)}
            labelColor={styles.title.color}
            labelHorizontalPadding={0}
            showLine={false}
            showTicks={false}
            styles={{
              tickLabelColor: styles.tickLabel.color,
            }}
            key="yaxis"
          />,
          <Grid key="grid" color={styles.grid.color} />,
          <LineChart key="line" color={PALETTE.lineChartColor} />,
          <ScatterChart key="scatter" color={PALETTE.lineChartColor} />,
        ]}
        {this.getOuterComponents(validData, chartData)}
        {children}
      </Chart>
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true
    }
  },
})(PriceHistoryChart);
